// 引入在线客服
export default {
    //时间戳转换为正常时间格式
    importKf: function () {
        $('body').append(`<script  style="display: none;"   id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=775ee965-e4eb-4d57-b608-a0b105a57f00"></script>`);
        
        window.zESettings = {
            webWidget: {
                position: { horizontal: 'left', vertical: 'bottom' },
                color: {
                    theme: '#0AB781',
                    launcher: '#0AB781',
                    launcherText: '#fff',
                    button: '#0AB781',
                    buttonText: '#fff',
                    resultLists: '#000',
                    header: '#0AB781',
                    articleLinks: '#FF4500'
                },
                offset: {
                    horizontal: '0px',
                    vertical: '20px',
                    mobile: {
                        horizontal: '0px',
                        vertical: '130px'
                    }
                },
                launcher: {
                    talkLabel: {
                        '*': 'Hello!',
                        fr: 'Bonjour!',
                        de: 'Hallo!'
                    },
                    mobile: {
                        labelVisible: true
                    },
                    label: {
                        'en-US': 'Need help?',
                        fr: "Besoin d'aide?"
                    },
                    mobile: {
                        labelVisible: true
                    },
                    badge: {
                        label: {
                            '*': 'xxx',
                            fr: 'Discute avec nous'
                        },
                        image: '',
                        layout: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAAQABAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCABLAEsDASIAAhEBAxEB/8QAGwABAAEFAQAAAAAAAAAAAAAAAAECAwQGCAf/xAAvEAABAwMEAgAEBAcAAAAAAAABAAIDBAURBgcSIRMxFBVBUVJhcYEIFyIykaHw/8QAHAEBAAICAwEAAAAAAAAAAAAAAAECBQYDBAcI/8QAKhEAAQMDBAEDAwUAAAAAAAAAAQACEQMSIQQFMUEiBhNxI2GBcpGh0fH/2gAMAwEAAhEDEQA/APW0RF8sr0ZERERERERERERERERVIipkkjjY58j2MawZc5zgA0fmT6VQJRVIoDmlnMOHHGeWesffKtGqphUMpzUQ+aRvJkfMcnD7ge8fmpDSeAkq8ioqJI6eF01Q9sMbRlz3niAP1Kt11XS0NO6etqI6eJoyXSO4/wDfopa1zogcoSAr6I3JYH8XgEZGWkf6KnDvwn/CqihFiU1xo6muqKKmmE01MQJ+HYicRkNcfQdjvHv74WWrOY5phwhAQeFpu9d2r7Ftfe7ta7jJbq2mjY6CeNjXODzI0BuHdd5x+i5ydVXtuk7to2lrKu9wxXKa41HCqhjNPSUr2ySy5wQXSOdkEk4DG4BzhdUao01Y9T0kFHf7dFcKaCYTsilc7hzAIBIBGeiej0tcvW0W3l2likqNOQwCKHwNZRyvpmcCSSC2MgEknsns/stu2HfNDt+n9uswk3XTaDxFvYOMnkcn7zjNbo6tZ9zDiI5P56XKV6uFVetawXOatrZYxJAwuuE/nlcGsDz5HDjywM9ho9AYWx7WMtbrteK3Wd1rKS2fJfNNK2eeORwc4BpjDmAOL3PcWgZwc4+pHQP8ltufiHz/ACWo5v5ZHzCfj/U0tPXLA6JQbLbcCkkpXWOd8Mnj5NfcJ3dMzxAJfkAcj0Olsdf1ltlSj7LQ9ogDAbIE9eXK6DNq1DX3Eg/v/S5kvkVdSWsavtgq7bbLjV/B2dtdXGaoibg86g/hJAwDgYyceg5bNvJp/T23VytsmmdUz1N/khYx7Zp/K+BzuzVteOmEgYA9jPIEdFe4Q7G7WxFxGl2u5NLTzq5ndH6jL+j9j9Fk0uzW2tNaKm1x6XgdDU48j5JZHzdHI4yF3Jv7Y/PK43estB7jHAvtbMi1vkDAAJLiTaJ/UT0pG1VrSMSe5OPjA5/heDbw042svVHT6Y1deZ7lV2smqfJXF5D3PA8nXrLQ4gHOOiCsfeOhg22qrCdJ6puM9yuFtkN0ea3yCUPaGhxA9B3J+Ac+gffa6Bteze29voKuiZpqGoZVtDJX1Mr5ZMA5Aa4nLPQ/twVFFszttSW2qoIdNR+KqAbM91RK6QtDg4NDy7LRkDIGM47yuKh6t0FM0773WyHeLfqTxPlgNzAz1kK79srOuiBPGTj4x32Vgfwz0NFbNpLPh9OK24eSqnIe3ySOc93HPeSeIC9PWmaR2u0LpO8tvFhsnwlc2N0bZTUyyYa4YPTnEevqtzWkbxqaOq1j69JxIeScgAiTxgnA+fwstpabqdIMcBjGP8CIoymVjYXYUooymUhFKKMplIRSijKZSEUooymUhFCIilERERERERERERERERF//9k='
                    }
                },
                contactForm: {
                    selectTicketForm: {
                        '*': 'Please choose:'
                    },
                    attachments: true,   //是否允许上传附件
                    fields: [
                        { id: 'email', prefill: { '*': 'My custom field text' } },
                        { id: 'phone', prefill: { '*': 'My custom field text' } },
                        { id: 'mobile', prefill: { '*': 'My custom field text' } }
                    ],
                    subject: true,
                },
                navigation: {
                    popoutButton: {
                        enabled: true
                    }
                }
            }
        };
    },
    // 购买
    // purchase(id,events){
    //     gtag('event', 'conversion', {'send_to': `${id}/${events}`,'transaction_id': ''});
    // },

}


// WEBPACK FOOTER //
// ./src/kf/kf.js